<template>
  <!-- 헤더 -->
  <MainHeader :isLoginPage="true" />

  <div class="main-layout">
    <!-- 대시보드 메인 -->
    <div class="dashboard-layout">
      <AppHeader />

      <div class="content-area flex flex-1">
        <div class="flex-1 bg-white p-4">
          <MainTable />
          <BottomBoard />
        </div>

        <div class="w-1/4 bg-white">
          <AppSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader.vue";
import AppHeader from "../components/AppHeader.vue";
import MainTable from "../components/MainTable.vue";
import AppSidebar from "../components/AppSidebar.vue";
import { mapActions, mapMutations } from "vuex";
import { storeName } from "@/global/variable";
import BottomBoard from "@/components/BottomBoard.vue";

// import { authFetch } from "@/plugins/axiosConfig";

export default {
  name: "MainDashboard",
  components: {
    MainHeader,
    AppHeader,
    MainTable,
    AppSidebar,
    BottomBoard,
  },
  data() {
    return {
      mpSse: null, // mark price sse
      assetSse: null, // asset/trade sse
      reconnecCount: 0,
    };
  },

  mounted() {
    this.initMarkPriceSSE();
    this.initAssetSSE();
    this.loadInitialData();
  },

  unmounted() {
    // 인스턴스가 존재할 때만 안전하게 해제
    if (this.mpSse) {
      this.mpSse.disconnect();
      console.log("MarkPrice SSE Disconnected");
    }
    if (this.assetSse) {
      this.assetSse.disconnect();
      console.log("Asset SSE Disconnected");
    }
  },
  methods: {
    ...mapMutations(storeName.markP, ["MU_UPDATE_MARK_PRICE"]),
    ...mapActions(storeName.asset, [
      "AT_LOAD_SYMBOL_CONFIG",
      "AT_GET_CUM_LIST",
    ]),
    ...mapActions(storeName.buyConfig, ["AC_GET_CONFIG", "AC_GET_ALL_CONFIGS"]),
    ...mapActions(storeName.manual, ["AT_GET_MANUAL"]),
    ...mapActions(storeName.tradeHistory, ["AT_GET_TRADE_HISTORY"]),

    /*
    ---- renewal start
    */
    // --- 초기 데이터 로드 로직 분리 ---
    loadInitialData() {
      this.$store.dispatch("assetStore/AT_REQ_BALANCE");
      this.$store.dispatch("assetStore/AT_UPDATE_SYMBOL_CONFIG");
      this.$store.dispatch("tradeStore/AT_GET_TRADE_HISTORY", {
        symbol: "BTCUSDT",
        position: "LONG",
      });
      this.$store.dispatch("tradeStore/AT_GET_CUM_LIST");
    },

    initMarkPriceSSE() {
      const token = this.$store.getters["userStore/ACCESS_TOKEN"];
      const url = `${
        process.env.VUE_APP_MARKP_BASE_URL
      }/sse/emitter?token=${encodeURIComponent(token)}`;

      this.mpSse = this.$sse.create({
        url: url,
        withCredentials: true,
      });

      this.mpSse.on("message", this.hanleMessage);
      this.mpSse.on("error", (e) => {
        console.error("MP SSE Error:", e);
        // 필요 시 여기서 재연결 로직 수행
      });

      this.mpSse
        .connect()
        .catch((err) => console.error("MP Connect Fail:", err));
    },
    // 자산/거래 SSE 초기화
    initAssetSSE() {
      const token = this.$store.getters["userStore/ACCESS_TOKEN"];
      const url = `${
        process.env.VUE_APP_BASE_URL
      }/sse/emitter?token=${encodeURIComponent(token)}`;

      this.assetSse = this.$sse.create({
        url: url,
        withCredentials: true,
      });

      // 리스너 등록 (가독성을 위해 객체 맵핑 권장)
      const handlers = {
        message: this.handleAssetMessage,
        trade: this.handleAssetTrade,
        account: this.handleAccountUpdate,
        position: this.handlePositionUpdate,
        leverage: this.handleLeverageUpdate,
        buystop: this.handleBuyStopMsg,
        tradeInit: this.handleTradeNew,
        tradeHistory: this.handleTradeHistory,
      };

      Object.keys(handlers).forEach((event) => {
        this.assetSse.on(event, handlers[event]);
      });

      this.assetSse
        .connect()
        .then(() => {
          console.log("✅ Asset SSE Connected");
        })
        .catch((err) => {
          console.error("❌ Asset SSE Connect Error:", err);
        });
    },

    /*
    ---- renewal end
    */

    handleGlobalAction(action, data) {
      console.log("Global Action:", action, data);
    },
    handleCoinAction(action, coinId) {
      console.log("Coin Action:", action, coinId);
    },
    hanleMessage(message) {
      // console.log(message);
      this.MU_UPDATE_MARK_PRICE(message);
    },
    // eslint-disable-next-line
    handleAssetMessage(message) {
      // console.log("message", message);
    },
    handleNextTrade(message) {
      const { symbol, position } = message;
      this.AC_GET_CONFIG({ symbol: symbol, position: position });
    },
    handleTradeNew(message) {
      const { symbol, tradeType, position } = message;
      if (tradeType === "b") {
        this.$toast.open({
          message: `${symbol} ${position} 물타기 거래가 요청 되었습니다`,
          type: "success",
        });
        this.AC_GET_CONFIG({
          symbol: symbol,
          position: position.toUpperCase(),
        });
      }
    },
    // 바이낸스 히스토리 업데이트
    async handleTradeHistory(message) {
      const { symbol, position } = message;

      this.AT_GET_TRADE_HISTORY({
        symbol: symbol.toUpperCase(),
        position: position.toUpperCase(),
      });
    },
    /**
     * 바이낸스 거래 주문 상태 변경 메시지 수신
     * @param message
     */
    async handleAssetTrade(message) {
      const { symbol, msg, tradeType } = message;
      let userMsg;
      let _tradeType;
      console.log(symbol, msg, tradeType);
      switch (msg) {
        case "NEW":
          userMsg = "생성";
          break;
        case "FILLED":
          userMsg = "채결";
          break;
        case "CANCELED":
          userMsg = "중지";
          break;
        case "PARTIALLY_FILLED":
          userMsg = "부분 체결";
          break;
        case "FAILED":
          userMsg = "실패";
          break;
      }
      if (tradeType != null) {
        switch (tradeType) {
          case "i":
            _tradeType = "포지션 진입";
            break;
          case "b":
            _tradeType = "물타기";
            break;
          case "t":
            _tradeType = "수익실현";
            break;
          case "f":
            _tradeType = "강제매도";
            break;
          case "mf":
            _tradeType = "수동 매도";
            break;
        }
      }
      if (userMsg != null) {
        if (msg === "FAILED") {
          this.$toast.open({
            message: `${symbol} ${_tradeType} 거래가 실패하였습니다`,
            type: "error",
          });
        } else {
          this.$toast.open({
            message: `${symbol} ${_tradeType} 거래가 ${userMsg} 되었습니다`,
            type: "success",
          });
        }

        if (msg === "FILLED" || msg === "FAILED") {
          switch (tradeType) {
            case "i":
            case "b":
              // 물타기 완전 체결시 && 초기 포지션 진입 완전 체결시
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              break;
            case "t":
              // 수익실현 완전 체결시
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              break;
            case "f":
              // 강제 매도 완전 체결시
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              break;
            case "mf":
              await this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
              await this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
              // window.location.reload();
              await this.$store.dispatch("assetStore/AT_UPDATE_BALANCE");
              break;
          }
          await this.AT_GET_MANUAL();
        }

        // TODO : 매수 설정 리스트 업데이트
      }
    },
    /**
     * 자산 변경 메시지 수신 (USDT)
     * @param message
     */
    handleAccountUpdate(message) {
      console.log(message);
      this.$store.dispatch("assetStore/AT_UPDATE_BALANCE");
    },
    /**
     * 포지션 정보 변경 메시지 수진 (symboi)
     * @param message
     */
    handlePositionUpdate(message) {
      console.log("=============position update");
      console.log(message);
      this.$store.dispatch("assetStore/AT_UPDATE_BALANCE");
    },
    /**
     * 레버리지 변경 메시지 수신
     * @param message
     */
    handleLeverageUpdate(message) {
      const { symbol } = message;
      this.$toast.open({
        message: `${symbol} 레버리지가 성공적으로 변경되었습니다.`,
        type: "success",
      });
      this.AT_LOAD_SYMBOL_CONFIG(symbol);
      this.AC_GET_CONFIG({ symbol: symbol, position: "LONG" });
      this.AC_GET_CONFIG({ symbol: symbol, position: "SHORT" });
    },

    /**
     * 사용자 추가 매수 중지 상태 업데이트 메시지 수신
     * @param message
     */
    // eslint-disable-next-line
    handleBuyStopMsg(message) {
      // manual buy stop api 호출 및 mutation 처리
      // console.log(message);
      this.AT_GET_MANUAL();
      this.AC_GET_ALL_CONFIGS();
    },
  },
};
</script>

<style scoped></style>
